import { AbsenceStatusValue } from './consts'

export const apiToUiAbsenceStatus = {
  [AbsenceStatusValue.APPROVED]: 'approved',
  [AbsenceStatusValue.PENDING]: 'pending',
  [AbsenceStatusValue.REJECTED]: 'rejected',
} as const

export const absenceRequestStatuses = [
  apiToUiAbsenceStatus[AbsenceStatusValue.APPROVED],
  apiToUiAbsenceStatus[AbsenceStatusValue.PENDING],
  apiToUiAbsenceStatus[AbsenceStatusValue.REJECTED],
] as const

export type AbsenceRequestStatus = (typeof absenceRequestStatuses)[number]
export type AbsenceRequestStatusOrEmpty = '' | AbsenceRequestStatus

export const uiToApiAbsenceStatus = {
  approved: AbsenceStatusValue.APPROVED,
  pending: AbsenceStatusValue.PENDING,
  rejected: AbsenceStatusValue.REJECTED,
} as const satisfies Record<AbsenceRequestStatus, AbsenceStatusValue>
